module.exports = __webpack_public_path__ + "static/media/IntelliDose_img.20aa6847.webp";